import React from 'react';
import {
  PeriodUnavailableState,
} from '../dashboardPrimitives';

export default function MiscExecutiveOverview({ selectedMonth = "Feb'26" }) {
  return <PeriodUnavailableState monthLabel={selectedMonth} />;
}
